// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/NotoSansKR-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/NotoSansKR-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/SUIT-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/Inter-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/SpoqaHanSansNeo-Regular.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(//spoqa.github.io/spoqa-han-sans/css/SpoqaHanSansNeo.css);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Noto Sans KR";
  src: local("Noto Sans KR"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
  font-weight: 500;
}
@font-face {
  font-family: "Noto Sans KR";
  src: local("Noto Sans KR"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype");
  font-weight: 700;
}
@font-face {
  font-family: "SUIT";
  src: local("SUIT"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("opentype");
  font-weight: 500;
}
@font-face {
  font-family: "Inter";
  src: local("Inter"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("opentype");
  font-weight: 500;
}
@font-face {
  font-family: "Spoqa Han Sans Neo";
  src: local("Spoqa Han Sans Neo"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("opentype");
  font-weight: 400;
}
a:-webkit-any-link {
  color: #353d47;
  cursor: pointer;
}

* {
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./src/styles/fonts.scss","webpack://./src/styles/index.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;EACA,sFAAA;EACA,gBAAA;ACEJ;ADAA;EACI,2BAAA;EACA,sFAAA;EACA,gBAAA;ACEJ;ADAA;EACI,mBAAA;EACA,8EAAA;EACA,gBAAA;ACEJ;ADCA;EACI,oBAAA;EACA,+EAAA;EACA,gBAAA;ACCJ;ADCA;EACI,iCAAA;EACA,4FAAA;EACA,gBAAA;ACCJ;AAtBA;EACI,cAAA;EACA,eAAA;AAwBJ;;AArBA;EACI,sBAAA;AAwBJ","sourcesContent":["@font-face {\n    font-family: 'Noto Sans KR';\n    src: local('Noto Sans KR'), url('../assets/fonts/NotoSansKR-Regular.otf') format('opentype');\n    font-weight: 500;\n}\n@font-face {\n    font-family: 'Noto Sans KR';\n    src: local('Noto Sans KR'), url('../assets/fonts/NotoSansKR-Bold.otf') format('opentype');\n    font-weight: 700;\n}\n@font-face {\n    font-family: 'SUIT';\n    src: local('SUIT'), url('../assets/fonts/SUIT-Regular.otf') format('opentype');\n    font-weight: 500;\n}\n\n@font-face {\n    font-family: 'Inter';\n    src: local('Inter'), url('../assets/fonts/Inter-Regular.otf') format('opentype');\n    font-weight: 500;\n}\n@font-face {\n    font-family: 'Spoqa Han Sans Neo';\n    src: local('Spoqa Han Sans Neo'), url('../assets/fonts/SpoqaHanSansNeo-Regular.otf') format('opentype');\n    font-weight: 400;\n}\n \n@import url(//spoqa.github.io/spoqa-han-sans/css/SpoqaHanSansNeo.css);\n","@import './fonts.scss';\n\n \na:-webkit-any-link {\n    color: #353d47;\n    cursor: pointer;\n}\n\n* {\n    box-sizing: border-box;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
